import { City } from "types/State";
import { BaseService } from "./baseService";

class CityService extends BaseService<City> {
  controllerName = "cities";
}

export const cityService = new CityService();
